(function () {
  'use strict';

  function bindAccordion(root) {
    root.querySelectorAll('.pg-mobile-premium details').forEach(function (detail) {
      if (detail.dataset.pgAccordionBound === 'true') return;
      detail.dataset.pgAccordionBound = 'true';

      detail.addEventListener('toggle', function () {
        if (!detail.open) return;
        root.querySelectorAll('.pg-mobile-premium details').forEach(function (other) {
          if (other !== detail) other.open = false;
        });
      });
    });
  }

  function fitPanelToViewport(panel) {
    if (!window.matchMedia('(min-width: 799px)').matches) {
      panel.style.removeProperty('--pg-panel-shift');
      return;
    }

    panel.style.setProperty('--pg-panel-shift', '0px');

    window.requestAnimationFrame(function () {
      var anchor = panel.offsetParent || document.documentElement;
      var anchorRect = anchor.getBoundingClientRect();
      var panelWidth = panel.offsetWidth;
      var edge = 24;
      var baseLeft = anchorRect.left + (anchorRect.width / 2) - (panelWidth / 2);
      var minLeft = edge;
      var maxLeft = Math.max(edge, window.innerWidth - edge - panelWidth);
      var desiredLeft = Math.min(Math.max(baseLeft, minLeft), maxLeft);
      var shift = desiredLeft - baseLeft;

      panel.style.setProperty('--pg-panel-shift', shift.toFixed(2) + 'px');
    });
  }

  function bindDesktopPanelContainment(root) {
    root.querySelectorAll('.pg-premium-panel--wide, .pg-premium-panel--compact').forEach(function (panel) {
      if (panel.dataset.pgContainmentBound === 'true') return;
      panel.dataset.pgContainmentBound = 'true';

      var item = panel.parentElement;
      if (!item) return;

      item.addEventListener('mouseenter', function () {
        fitPanelToViewport(panel);
      });

      item.addEventListener('focusin', function () {
        fitPanelToViewport(panel);
      });
    });
  }


  function bindDesktopHoverIntent(root) {
    if (!window.matchMedia('(min-width: 799px)').matches) return;

    root.querySelectorAll('.pg-has-panel').forEach(function (item) {
      if (item.dataset.pgHoverIntentBound === 'true') return;
      item.dataset.pgHoverIntentBound = 'true';

      var closeTimer = null;

      function openPanel() {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        item.classList.add('pg-panel-open');
      }

      function scheduleClose() {
        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          if (!item.matches(':hover') && !item.contains(document.activeElement)) {
            item.classList.remove('pg-panel-open');
          }
        }, 260);
      }

      item.addEventListener('mouseenter', openPanel);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', openPanel);
      item.addEventListener('focusout', scheduleClose);
    });
  }

  function refitOpenPanels() {
    document.querySelectorAll('.pg-premium-panel--wide, .pg-premium-panel--compact').forEach(function (panel) {
      if (panel.matches(':hover') || panel.parentElement.matches(':hover') || panel.parentElement.contains(document.activeElement)) {
        fitPanelToViewport(panel);
      }
    });
  }

  function init(root) {
    bindAccordion(root || document);
    bindDesktopPanelContainment(root || document);
    bindDesktopHoverIntent(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  window.addEventListener('resize', refitOpenPanels, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
